/*
 *
 *  Mixin - Head Meta
 */

// export
export default {
  // metaInfo
  metaInfo() {
    // init info
    var info = {}
    /*
     * Info
     */
    // set title template
    if (this.hmTitleTemplate && !this.hmDisableTitleTemplate) {
      info.titleTemplate = titleChunk => {
        var template = ''
        if (titleChunk) template += titleChunk + ' - '
        if (this.hmTitleTemplate) template += this.hmTitleTemplate
        return template ? `${template} • ${this.gVars.appName}` : this.gVars.appName
      }
    }
    // diable template
    if (this.hmDisableTitleTemplate) info.titleTemplate = false
    // set main title
    if (this.hmTitle) info.title = this.hmTitle
    // save fullUrl
    var fullTitle = ''
    if (this.hmTitle) fullTitle += this.hmTitle
    if (this.hmTitleTemplate) fullTitle += ` - ${this.hmTitleTemplate}`
    if (this.hmDisableTitleTemplate) fullTitle = fullTitle ? fullTitle : this.gVars.appName
    else fullTitle = fullTitle ? `${fullTitle} • ${this.gVars.appName}` : this.gVars.appName
    /*
     * Meta
     */
    info.meta = []
    // og title
    info.meta.push({ property: 'og:title', content: fullTitle })
    // twitter title
    info.meta.push({ name: 'twitter:title', content: fullTitle })
    // Google / Schema.org markup
    info.meta.push({ itemprop: 'name', content: fullTitle })
    // set meta descriptions
    if (this.hmDescription) {
      // main description
      info.meta.push({ name: 'description', content: this.hmDescription })
      // og description
      info.meta.push({
        property: 'og:description',
        content: this.hmDescription
      })
      // twitter description
      info.meta.push({
        name: 'twitter:description',
        content: this.hmDescription
      })
      // Google / Schema.org markup
      info.meta.push({
        itemprop: 'description',
        content: this.hmDescription
      })
    }
    // set meta url
    if (this.hmUrl) {
      // set canonical link
      info.link = [{ rel: 'canonical', href: this.hmUrl }]
      // og url
      info.meta.push({ property: 'og:url', content: this.hmUrl })
      // twitter url
      info.meta.push({ name: 'twitter:site', content: this.hmUrl })
    }
    // set meta thumb
    var hmThumb = this.hmThumb
    if (!hmThumb) hmThumb = this.gVars.brandUrls.md
    // add url
    hmThumb = this.gVars.appUrl + hmThumb
    // og image
    info.meta.push({ property: 'og:image', content: hmThumb })
    // twitter image
    info.meta.push({ name: 'twitter:image:src', content: hmThumb })
    // Google / Schema.org markup
    info.meta.push({ itemprop: 'image', content: hmThumb })
    // set twitter card type
    const type = this.headCardType ? this.headCardType : 'summary_large_image'
    info.meta.push({ name: 'twitter:card', content: type })
    // temp log
    //console.log('Head Meta - Info', info)
    // return data
    return info
  }
}
